/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Searchheader_Results1Inputs */

const id_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hasil`)
};

const ms_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} hasil`)
};

const da_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultater`)
};

const de_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Ergebnisse`)
};

const en_us2_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

const es_es2_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultados`)
};

const es_mx2_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultados`)
};

const fil_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resulta`)
};

const fr_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} résultats`)
};

const it_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} risultati`)
};

const hu_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} találat`)
};

const nl_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultaten`)
};

const no_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultater`)
};

const pl_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} wyników`)
};

const pt_br2_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

const pt_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultados`)
};

const ro_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} rezultate`)
};

const fi_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} tulosta`)
};

const sv_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} resultat`)
};

const vi_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} kết quả`)
};

const tr_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} sonuç`)
};

const cs_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} výsledků`)
};

const bg_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} резултата`)
};

const ru_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} результатов`)
};

const uk_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} результатів`)
};

const ar_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} نتيجة`)
};

const hi_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} परिणाम`)
};

const th_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} ผลลัพธ์`)
};

const ja_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 件の結果`)
};

const zh_cn2_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

const zh_hant1_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

const ko_components_searchheader_results1 = /** @type {(inputs: Components_Searchheader_Results1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} results`)
};

/**
* | output |
* | --- |
* | "{count} results" |
*
* @param {Components_Searchheader_Results1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_searchheader_results1 = /** @type {((inputs: Components_Searchheader_Results1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Searchheader_Results1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_searchheader_results1(inputs)
	if (locale === "ms") return ms_components_searchheader_results1(inputs)
	if (locale === "da") return da_components_searchheader_results1(inputs)
	if (locale === "de") return de_components_searchheader_results1(inputs)
	if (locale === "en-US") return en_us2_components_searchheader_results1(inputs)
	if (locale === "es-ES") return es_es2_components_searchheader_results1(inputs)
	if (locale === "es-MX") return es_mx2_components_searchheader_results1(inputs)
	if (locale === "fil") return fil_components_searchheader_results1(inputs)
	if (locale === "fr") return fr_components_searchheader_results1(inputs)
	if (locale === "it") return it_components_searchheader_results1(inputs)
	if (locale === "hu") return hu_components_searchheader_results1(inputs)
	if (locale === "nl") return nl_components_searchheader_results1(inputs)
	if (locale === "no") return no_components_searchheader_results1(inputs)
	if (locale === "pl") return pl_components_searchheader_results1(inputs)
	if (locale === "pt-BR") return pt_br2_components_searchheader_results1(inputs)
	if (locale === "pt") return pt_components_searchheader_results1(inputs)
	if (locale === "ro") return ro_components_searchheader_results1(inputs)
	if (locale === "fi") return fi_components_searchheader_results1(inputs)
	if (locale === "sv") return sv_components_searchheader_results1(inputs)
	if (locale === "vi") return vi_components_searchheader_results1(inputs)
	if (locale === "tr") return tr_components_searchheader_results1(inputs)
	if (locale === "cs") return cs_components_searchheader_results1(inputs)
	if (locale === "bg") return bg_components_searchheader_results1(inputs)
	if (locale === "ru") return ru_components_searchheader_results1(inputs)
	if (locale === "uk") return uk_components_searchheader_results1(inputs)
	if (locale === "ar") return ar_components_searchheader_results1(inputs)
	if (locale === "hi") return hi_components_searchheader_results1(inputs)
	if (locale === "th") return th_components_searchheader_results1(inputs)
	if (locale === "ja") return ja_components_searchheader_results1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_searchheader_results1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_searchheader_results1(inputs)
	return ko_components_searchheader_results1(inputs)
});
export { components_searchheader_results1 as "components.searchHeader.results" }